import { CultevaIndexChartTypes } from '../report';

export enum IndexDataPointType {
    CHARACTERISTIC = 'CHARACTERISTIC',
    INDEX = 'INDEX',
}

type axis = 'x' | 'y';
type position = 'top' | 'bottom' | 'left' | 'right';

// TODO check where types like these can be placed for general usage among chart components
interface ChartTitle {
    display: boolean;
    text: string;
    type?: string;
    padding: number;
    font: {
        weight: string;
        size: number;
    }
}

interface ChartFont {
    weight?: string;
    size: number;
}

interface ChartPlugins {
    legend?: {
        display: boolean;
    }
    title?: {
        display: boolean;
        text: string;
        position: position;
        font: ChartFont;
    }
}

interface ChartPointLabels {
    font: ChartFont
}

interface ChartTooltips {
    mode: string;
    axis?: axis;
    enabled?: boolean;
}

export interface IndexDataPoint {
    id: string;
    weight: number;
    isNegative: boolean;
    type: IndexDataPointType;
}

export interface RadarIndexConfig {
    plugins?: ChartPlugins
    tooltips: ChartTooltips
    scales: {
        r: {
            angleLines: {
                display: boolean;
            },
            min: number;
            max: number;
            pointLabels: ChartPointLabels
        },
    }
    aspectRatio: number;
}

export interface BarIndexConfig {
    tooltips: ChartTooltips;
    plugins: ChartPlugins;
    indexAxis: 'y'; //? set char as horizontal bar graph
    scales: {
        x: {
            min: number;
            max: number;
            ticks: {
                stepSize: number;
            }
            title: ChartTitle;
        }
        y: {
            title: ChartTitle;
            ticks: {
                autoSkip: boolean;
                maxTicksLimit: number
            }
        }
    }
    responsive: boolean;
}

export const BAR_INDEX_DEFAULT_CONFIG: BarIndexConfig = {
    tooltips: {
        mode: 'point'
    },
    plugins: {
        legend: {
            display: true,
        },
    },
    indexAxis: 'y',
    scales: {
        x: {
            min: 0,
            max: 100,
            ticks: {
                stepSize: 10,
            },
            title: {
                type: 'linear',
                display: true,
                text: 'Score (%)',
                padding: 6,
                font: {
                    weight: 'bold',
                    size: 14,
                }
            },
        },
        y: {
            title: {
                display: true,
                text: 'Characteristic',
                padding: 6,
                font: {
                    weight: 'bold',
                    size: 14,
                }
            },
            ticks: {
                autoSkip: false,
                maxTicksLimit: 11,
            },
        }
    },
    responsive: true,
}

export const RADAR_INDEX_DEFAULT_CONFIG: RadarIndexConfig = {
            tooltips: {
                enabled: true,
                mode: 'index'
            },
            plugins: {
                legend: {
                    display: true,
                },
            },
            scales: {
                r: {
                    angleLines: {
                        display: true,
                    },
                    min: 0,
                    max: 100,
                    pointLabels: {
                        font: {
                            size: 12
                        }
                    },
                }
            },
            aspectRatio: 2,
}


export const getDefaultIndexConfig = (type: keyof CultevaIndexChartTypes): RadarIndexConfig | BarIndexConfig | null => {
    if (type === 'radar') return RADAR_INDEX_DEFAULT_CONFIG;
    if (type === 'bar') return BAR_INDEX_DEFAULT_CONFIG;

    return null;
}

export const setIndexConfigOptions = (type: keyof CultevaIndexChartTypes, config: any, chartTitle?: string) => {
    let defaultConfig = getDefaultIndexConfig(type);

    chartTitle = chartTitle || null;

    defaultConfig.plugins = {
        ...defaultConfig.plugins,
        title: {
            ...defaultConfig.plugins.title,
            display: chartTitle != null ? true : false,
            text: chartTitle,
        }
    }

    return {
        ...defaultConfig,
        ...config,
    };
}